const oneKilobyte = 1028
const maxPlaceholderDescChar = 250

function validateLogoCategory(file) {
  const maxImageSize = oneKilobyte * 500
  try {
    return !(file.size > maxImageSize)
  } catch (e) {
    return false
  }
}

export {
  validateLogoCategory,
  maxPlaceholderDescChar,
}
